export function fetchDeepZoomImageFailed() {
  return {
    type: "fetchDeepZoomImageFailed",
  };
}
